export default function genererDelaiReglementDetail() {
  return {
    nombreJourDecalage: null,
    finDeMois: null,
    jourFinDeMois: null,
  };
}
